import { __read, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { useOverlay, useOverlayPosition, FocusScope } from 'react-aria';
import { useRef, useState, useEffect } from 'react';
import clsx from 'clsx';
import styles from './Popover.module.scss.js';

var ANIMATION_TIME = 300;
var Popover = function (_a) {
    var _b;
    var children = _a.children, _c = _a.placement, placement = _c === void 0 ? 'bottom start' : _c, _d = _a.offset, offset = _d === void 0 ? 4 : _d, isOpen = _a.isOpen, onClose = _a.onClose, overlayRef = _a.overlayRef, triggerRef = _a.triggerRef, className = _a.className, style = _a.style, _e = _a.restoreFocus, restoreFocus = _e === void 0 ? true : _e, hasFocusTrap = _a.hasFocusTrap, hasAutoFocus = _a.hasAutoFocus, _f = _a.shouldFlip, shouldFlip = _f === void 0 ? true : _f;
    var localRef = useRef(null);
    var ref = overlayRef || localRef;
    var _g = __read(useState(undefined), 2), triggerWidth = _g[0], setTriggerWidth = _g[1];
    var _h = __read(useState(undefined), 2), triggerHeight = _h[0], setTriggerHeight = _h[1];
    useEffect(function () {
        var _a, _b;
        setTriggerWidth((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width);
        setTriggerHeight((_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height);
    }, [triggerRef]);
    useEffect(function () {
        var handleResize = function () {
            var _a, _b;
            setTriggerWidth((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width);
            setTriggerHeight((_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [triggerRef]);
    var overlayProps = useOverlay({
        isOpen: isOpen,
        onClose: onClose,
        shouldCloseOnBlur: false,
        isDismissable: true,
    }, ref).overlayProps;
    var overlayStyle = useOverlayPosition({
        targetRef: triggerRef,
        overlayRef: ref,
        placement: placement === 'on-trigger' ? 'bottom' : placement,
        offset: placement === 'on-trigger' ? -(triggerHeight || 0) : offset,
        isOpen: isOpen,
        shouldFlip: shouldFlip,
    }).overlayProps.style;
    return (jsx(Fragment, { children: typeof window !== 'undefined' &&
            createPortal(jsx(CSSTransition, __assign({ in: isOpen, timeout: ANIMATION_TIME, classNames: {
                    enter: clsx(styles.popoverEnter, (_b = {}, _b[styles.popoverEnterOnTrigger] = placement === 'on-trigger', _b)),
                    enterActive: styles.popoverEnterActive,
                    exit: styles.popoverExit,
                    exitActive: styles.popoverExitActive,
                }, unmountOnExit: true, nodeRef: ref }, { children: jsx(FocusScope, __assign({ restoreFocus: restoreFocus, autoFocus: hasAutoFocus, contain: hasFocusTrap }, { children: jsx("div", __assign({}, overlayProps, { className: clsx(styles.popover, className), style: __assign(__assign(__assign({}, overlayStyle), { width: triggerWidth, maxWidth: triggerWidth }), style), ref: ref }, { children: children })) })) })), document.querySelector('#portals')) }));
};

export { Popover };
